<template>
  <ContentSection>
    <Container
      indent="center"
      :class="{
        '-mt-10 sm:mt-[-6.5rem] ': index === 0 && listType === 'regular',
      }"
    >
      <!-- MAP -->
      <div v-if="listType === 'regular'">
        <SwitzerlandMap
          :parsed-list="list"
          class="text-[#EAF6FD]"
          @canton-click="handleCantonClick($event)"
        />
      </div>
      <div ref="table">
        <div v-show="selectedCanton || listType === 'friend'">
          <!-- TITLE -->
          <h2
            v-if="listType === 'regular'"
            class="mb-6 mt-12 max-w-title text-2xl font-medium"
          >
            <template v-if="selectedCanton !== 'FL'">
              {{ $t('members_in_canton') }}
            </template>

            <template v-else>
              {{ $t('members_in') }}
            </template>
            {{ $t(`cantons.${selectedCanton}`) }}
          </h2>

          <h2
            v-else-if="listType === 'friend' && data.heading"
            class="mb-6 mt-12 max-w-title text-2xl font-medium"
            v-html="$replaceHtmlTags(data.heading)"
          />

          <!-- TABLE -->
          <AnimatedContainer
            :key="list[selectedCanton] || list"
            :stagger="0.025"
          >
            <table class="w-full">
              <thead>
                <tr class="text-left align-top text-sm opacity-50">
                  <th class="pb-4 pl-4 font-normal">{{ $t('members') }}</th>
                  <th class="px-3 pb-4 font-normal">{{ $t('location') }}</th>
                  <th />
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(item, i) in listType === 'regular'
                    ? list[selectedCanton]
                    : list"
                  :key="item.id"
                  class="fade-in"
                  :class="{ 'bg-blue-10': i % 2 === 0 }"
                >
                  <td class="hyphens-auto py-6 pl-4 font-medium">
                    {{ item.name }}
                  </td>
                  <td class="hyphens-auto px-3 py-6">{{ item.location }}</td>
                  <td class="py-6 pr-4">
                    <AppLink v-if="item.url" class="font-normal" :to="item.url">
                      {{ $t('website') }}
                    </AppLink>
                  </td>
                </tr>
              </tbody>
            </table>
          </AnimatedContainer>
        </div>
      </div>
    </Container>
  </ContentSection>
</template>

<script setup>
const props = defineProps({
  data: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
})

// REFS
const table = ref(null)

// FUNCTION
function handleCantonClick(canton) {
  selectedCanton.value = canton
  scrollTo(table.value)
}

function scrollTo(element) {
  if (!element) {
    return
  }

  const headerOffset = 200
  const elementPosition = element.offsetTop
  const offsetPosition = elementPosition - headerOffset

  window.scrollTo({
    top: offsetPosition,
    behavior: 'smooth',
  })
}

// COMPUTED
const listType = computed(() => {
  if (props.data.parsed_list_members_regular) {
    return 'regular'
  }

  if (
    Array.isArray(props.data.parsed_list_members_friend) &&
    props.data.parsed_list_members_friend.length > 0
  ) {
    return 'friend'
  }

  return 'none'
})

const list = computed(() => {
  if (listType.value === 'regular') {
    return props.data.parsed_list_members_regular
  }

  if (listType.value === 'friend') {
    return props.data.parsed_list_members_friend || []
  }

  return []
})

// VARIABLES
const selectedCanton = ref(null)
</script>
